import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { AppTableHeader, ColumnStatus, PaymentStatus, TableColumnTypes } from '../../model/table.model';
import { SelectionModel } from '@angular/cdk/collections';
import {
  ADVERT_PLANNER_TYPE,
  CHANNEL_STATUS,
  CHANNEL_TYPE,
  CHANNEL_TYPES_OBJECT,
  ERROR_MESSAGES_STRING,
  MEMBERSHIP_STATUS_CHIPS,
  activeTranslations,
  status_table_nova_poshta,
  status_table_olx_adverts,
  status_table_planner,
  TChannelTypeObject,
  USER_COMPANY_STATUS,
} from '../../enum/constants';
import { BaseService } from '../../services/base.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotificationService } from '../../services/notifications.service';
import { AudioService } from '../../services/audio.service';
import * as _ from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { isEllipsisActive } from '../../helpers/utils';
import { POWER_OLX_FILTERS_MAP } from '../../modules/crm/power-olx-v2/interfaces/power-olx-tab.interface';
import { PowerOlxV2Tab } from '../tabs/enums/tabs.enum';
import {
  OLX_DELIVERY_DEPARTMENTS_MAP,
  OlxDeliveryWaybill,
  OlxItem,
} from '../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import moment from 'moment';
import { PLANNER_STATUS } from '../layout/stacked-sidebar/components/planner-v2/planner-v2.interface';
import { PLANNER_FILTERS } from '../../interfaces/planner-table.interface';
import { TranslateService } from '@ngx-translate/core';
import { CrmService } from '../../services/crm.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableComponent implements OnInit, AfterViewInit {
  // Destroy
  private readonly destroy$: Subject<null> = new Subject<null>();

  // Input's
  @Input() dataSource!: any;
  @Input() visibleColumnKeys!: string[];
  @Input() showPagination: boolean = true;
  @Input() showUpPagination: boolean = false;
  @Input() isLoader: boolean = false;
  @Input() classImage: string = '';
  @Input() customClass: string = '';

  // Output's
  @Output() onSortChange = new EventEmitter();
  @Output() onTableRowClick = new EventEmitter();
  @Output() onTableRowCheck = new EventEmitter();
  @Output() onPaginationChange = new EventEmitter();
  @Output() isAllRowsSelected = new EventEmitter<boolean>();
  @Output() menuSelected = new EventEmitter();
  @Output() onChangeRow = new EventEmitter();
  @Output() onSelectRow = new EventEmitter();

  /** Checkbox events  */
  @Input() selection = new SelectionModel<any>(true, []);

  // Constants
  manualSortEnabled: boolean = false;
  playId: string = '';
  pageCount!: number;

  actions: string[] = [];

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    public readonly baseService: BaseService,
    public readonly clipboard: Clipboard,
    public readonly notificationService: NotificationService,
    public readonly audioService: AudioService,
    public readonly translate: TranslateService,
    protected readonly crmService: CrmService,
  ) {
  }

  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit() {
    if (this.dataSource?.headers) {
      for (const header of this.dataSource.headers) {
        /** Action  */
        if (header.type === TableColumnTypes.ACTION) {
          if (header.actions) {
            for (const action of header.actions) {
              this.actions.push(action);
            }
          }
        }

        if (header.type === TableColumnTypes.AUDIO) {
          this.audioService.currentAudio$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
              this.changeDetectorRef.detectChanges();
            });

          this.audioService.playAudio$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
              this.changeDetectorRef.detectChanges();
            });
        }
      }
    }
  }

  ngAfterViewInit() {
    const s: any = this.dataSource?.headers.find((e: any) => {
      if (e.sort != 'none') return e.value;
    });
    this.manualSortEnabled = true;
    if (s) {
      this.sort?.sort({
        id: s.value,
        start: s.sort,
        disableClear: false,
      });
    }
    this.manualSortEnabled = false;
    this.changeDetectorRef.detectChanges();
    // this.dataSource.headers.s = this.sort;
  }


  /** sorting */
  announceSortChange(sortState: Sort) {
    if (!this.manualSortEnabled) this.onSortChange.emit(sortState);
  }

  onRowClick(row: any, column: any) {
    this.onTableRowClick.emit({ row, column });
  }

  cellClicked(row: any, column: string) {

    const columns = ['stage', 'priority', 'image_url', 'audio_url'];
    if (column && !columns.includes(column))
      this.onRowClick(row, column);
    else {
      if (column === 'audio_url') {
        if (!row.audio_url) return;
        const audio_urls = this.dataSource.rows
          .filter((v: any) => !!v.audio_url)
          .map((v: any) => v.audio_url);
        if (!_.isEqual(audio_urls, this.audioService.audioSource)) this.audioService.audioSource = audio_urls;

        this.audioService.setIsPlay(this.audioService.currentAudio !== row.audio_url || !this.audioService.isPlay);
        if (this.audioService.currentAudio !== row.audio_url) this.audioService.setCurrentAudio(row.audio_url);
      }
    }
    // }

  }

  onCheckRow(row: any) {
    this.selection.toggle(row);
    this.onTableRowCheck.emit(row);
  }

  onPagination(paginationDetails: any) {
    if (this.dataSource?.pageSize) {
      this.pageCount = Math.round(this.dataSource.length / paginationDetails.pageSize);
    }
    this.onPaginationChange.emit(paginationDetails);
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.isAllRowsSelected.emit(false);
      return;
    }
    this.isAllRowsSelected.emit(true);
    this.selection.select(...this.dataSource.rows);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.rows.length;
    return numSelected === numRows;
  }

  getActionList(actions: any[], row: any): any[] {
    return (actions || []).filter((item: any) => !item.unseen?.([row], this.crmService));
  }

  /** Action Menu  Value Changed */
  menuOnSelect(selectedMenu: any, event: any) {
    const eventValue: any = { label: event.value };
    const objectWithEvent = Object.assign(selectedMenu, eventValue);
    this.menuSelected.emit(objectWithEvent);
    if (event?.action) event.action(selectedMenu);
  }


  protected readonly TableColumnTypes = TableColumnTypes;
  protected readonly status_table_nova_poshta = status_table_nova_poshta;

  formatPhone(rowElement: any) {
    let phoneNumber: string = rowElement.toString();

    if (phoneNumber.charAt(0) !== '+') {
      phoneNumber = '+' + phoneNumber;
    }
    return phoneNumber;
  }

  onCopy(event: any, value: any) {
    event.stopPropagation();
    if (this.clipboard.copy(value)) {
      this.notificationService.showInfo('', activeTranslations.notifications_texts.info.copied);
    }
  }

  arrayFormat(value: any[]) {
    return this._filter(value).map(this.formatPhone).join(', ');
  }

  _filter(value: any[]) {
    return (value || []).filter(v => !!v);
  }

  millisecondsToTime(milliseconds: any): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let formattedTime = '';

    if (hours > 0) {
      formattedTime += hours + ':';
    }

    formattedTime += (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    return formattedTime;
  }

  protected getChannelObject(channel: any): TChannelTypeObject | undefined {
    return CHANNEL_TYPES_OBJECT[channel as CHANNEL_TYPE];
  }

  protected getPaymentInfo(payment: any): any {
    if (payment.description) {
      return payment.description;
    }

    return '-';
  }

  protected getPlannerStatus(status: PLANNER_STATUS) {
    const plannerStatus = PLANNER_FILTERS
      .find((v) => v.values.includes(status));

    return {
      icon: plannerStatus?.icon ?? 'help_outline',
      text: plannerStatus?.name ?? 'status_not_found',
      color: plannerStatus?.color ?? 'gray',
    };
  }

  protected getPowerOlxStatus(row: OlxItem): ColumnStatus {
    if (row.tab_type === PowerOlxV2Tab.DELIVERIES) {
      return this.getDeliveryPowerOlxStatus(row);
    }

    const powerOlxStatus = POWER_OLX_FILTERS_MAP[row.tab_type]
      .find((v) => 'status' in row && v.values.includes(row.status));

    return {
      icon: powerOlxStatus?.icon ?? 'help_outline',
      text: powerOlxStatus?.name ?? 'status_not_found',
      color: powerOlxStatus?.color ?? 'gray',
    };
  }

  private getDeliveryPowerOlxStatus(row: OlxItem): ColumnStatus {
    const delivery = activeTranslations.olx.delivery;

    const status: ColumnStatus = {
      icon: 'help_outline',
      text: delivery.status.data_error,
      color: 'gray',
    };

    if (!('statusShort' in row)) return status;

    const filter = POWER_OLX_FILTERS_MAP[row.tab_type]
      .find((v) => 'statusShort' in row && v.values.includes(row.statusShort));

    if (filter?.color) {
      status.color = filter.color;
    }
    if (filter?.icon) {
      status.icon = filter.icon;
    }

    let text: string = delivery.status[row.statusShort][row.status];
    const needsExpiration = ['accepted', 'money_blocked'].includes(row.status);
    if (needsExpiration && row.expiresAt) {
      text += moment(row.expiresAt).format('D MMMM, HH:mm');
    }
    if (text) {
      status.text = text;
    }

    return status;
  }

  protected onChange(value: boolean, row: any) {
    this.onChangeRow.emit({ row, value });
  }

  protected onSelect(value: any, row: any, header: AppTableHeader) {
    row[header.value] = value;
    this.onSelectRow.emit({ row, value, column: header.value });
  }

  protected readonly status_table_planner = status_table_planner;
  protected readonly ADVERT_PLANNER_TYPE = ADVERT_PLANNER_TYPE;
  protected readonly status_table_olx_adverts = status_table_olx_adverts;
  protected readonly CHANNEL_STATUS = CHANNEL_STATUS;
  protected readonly isEllipsisActive = isEllipsisActive;
  protected readonly ERROR_MESSAGES_STRING = ERROR_MESSAGES_STRING;
  protected readonly PowerOlxV2Tab = PowerOlxV2Tab;
  protected readonly OLX_DELIVERY_DEPARTMENTS_MAP: Record<string, OlxDeliveryWaybill> = OLX_DELIVERY_DEPARTMENTS_MAP;
  protected readonly PaymentStatus = PaymentStatus;
  protected readonly MEMBERSHIP_STATUS_CHIPS: Record<string, (typeof MEMBERSHIP_STATUS_CHIPS)[USER_COMPANY_STATUS]> =
    MEMBERSHIP_STATUS_CHIPS;
}
